<template>
    <div class="availabilities-year-calendar">
        <div class="toolbar">
            <router-link v-for="(y, idx) in years" :key="idx" :to="{ name: 'availabilities-index', params: { year: y, lang: lang }, query: $route.query }" class="button" :class="{'is-active': y === year, 'is-loading': loading}">
                <span @click="onYearClicked(y)">{{ y }}</span>
            </router-link>
        </div>
        <div class="columns is-multiline">
            <div class="column is-3-tablet is-2-desktop" v-for="availability of availabilities" :key="availability.idx">
                <router-link :to="{ name: 'availabilities-by-month', params: { year: year, month: availability.month, lang: lang } }" class="box availability-box active" :class="{'is-loading': loading}" v-if="!isPast(year, availability.month)">
                    <span @click="onMonthClicked(year, availability.month)">
                        <div class="month-name">{{ $t('generic.calendar.monthnames.long')[availability.month - 1] }}</div>
                        <battery v-model="availability.percent" v-if="!loading"></battery>
                    </span>
                </router-link>
                <span class="box availability-box inactive" :class="{'is-loading': loading}" v-else>
                    <span @click="onComponentClicked(availability.idx, year, availability.month)">
                        <div class="month-name">{{ $t('generic.calendar.monthnames.long')[availability.month - 1] }}</div>
                        <battery v-model="availability.percent" v-if="!loading"></battery>
                        <info-i :showI="false" :shown="flyoutShown[availability.idx]" @hide="onHideFlyoutRequested(availability.idx)">
                            {{ $t('availabilities.flyouts.invalidMonth') }}
                        </info-i>
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { AppModel } from '../../../models';
    import { Tracking } from '../../../utils';
    import Battery from './battery';
    import InfoI from './info-i';

    export default {
        name: 'availabilities-year-calendar',

        components: {
            Battery,
            InfoI,
        },

        props: {
            year: {
                type: Number,
                'default': () => { return new Date().getFullYear(); },
            },
            availabilities: {
                type: Array,
                'default': () => { return []; },
            },
            loading: {
                type: Boolean,
                'default': () => { return false; },
            },
        },

        data() {
            return {
                flyoutShown: [false, false, false, false, false, false, false, false, false, false, false, false],
            };
        },

        computed: {
            years() {
                const y = new Date().getFullYear();
                return [y, y + 1, y + 2, y + 3];
            },
            lang() {
                return AppModel.lang;
            },
        },

        methods: {
            isPast(year, month) {
                return new Date(year, month, 0).getTime() < new Date().getTime();
            },
            onComponentClicked(idx, year, month) {
                const m = month < 10 ? `0${month}` : month;
                Tracking.trackEvent('AvailabilitiesIntro', 'invalidMonthClicked', `${year}-${m}`);
                this.flyoutShown.splice(idx, 1, !this.flyoutShown[idx]);
            },
            onHideFlyoutRequested(idx) {
                this.flyoutShown.splice(idx, 1, false);
            },
            onYearClicked(year) {
                Tracking.trackEvent('AvailabilitiesIntro', 'yearClicked', year);
            },
            onMonthClicked(year, month) {
                const m = month < 10 ? `0${month}` : month;
                Tracking.trackEvent('AvailabilitiesIntro', 'monthClicked', `${year}-${m}`);
            },
        },
    };
</script>

<style lang="scss">
    @import './availabilities-year-calendar.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/availabilities/availabilities-year-calendar.vue